/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stop_Call_ExtraInputs */

const fr_stop_call_extra = /** @type {(inputs: Stop_Call_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desserte supplémentaire`)
};

const en_stop_call_extra = /** @type {(inputs: Stop_Call_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional stop`)
};

/**
* | output |
* | --- |
* | "Additional stop" |
*
* @param {Stop_Call_ExtraInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const stop_call_extra = /** @type {((inputs?: Stop_Call_ExtraInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stop_Call_ExtraInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_stop_call_extra(inputs)
	return en_stop_call_extra(inputs)
});